import { Navigate, Outlet } from 'react-router-dom';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useMeProfile } from '../hooks/useApi';

export function TermsGate() {
  const { data, isLoading, isError, error, refetch } = useMeProfile();

  if (isLoading) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh" px={2}>
        <Alert severity="error" onClose={() => refetch()}>
          {error instanceof Error ? error.message : 'Failed to load profile.'}
        </Alert>
      </Box>
    );
  }

  const accepted = Boolean(data?.termsAcceptedAt?.trim());

  if (!accepted) {
    return <Navigate to="/terms" replace />;
  }

  return <Outlet />;
}
